// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppPage_container__5kV8S {
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100vw;
  padding: 5rem;
}

.AppPage_appright__FbFDS {
  box-sizing: border-box;
  padding: 3rem 3rem;
  width: 80vw;
}
@media only screen and (max-width: 62.5em) {
  .AppPage_appright__FbFDS {
    width: 90%;
  }
}
@media only screen and (max-width: 50em) {
  .AppPage_appright__FbFDS {
    width: 100%;
  }
}

.AppPage_topside__6Eu7D {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.AppPage_topside_left__srd81 {
  display: flex;
  align-items: center;
}
.AppPage_topside_left__srd81 > :not(:last-child) {
  margin-right: 2rem;
}
.AppPage_topside_1__tBdsp {
  display: flex;
  align-items: center;
}
.AppPage_topside_1__tBdsp > :not(:last-child) {
  margin-right: 3rem;
}
.AppPage_topside_welcome__13qU2 {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.AppPage_topside_name__7zj2X {
  color: var(--color-primary);
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  line-height: 3rem;
}
.AppPage_topside_icon__i8-cz {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .AppPage_topside_icon__i8-cz {
    margin-bottom: 1rem;
  }
}
.AppPage_topside__6Eu7D h3 {
  font-size: var(--default-font-h3);
  line-height: 3.6rem;
}
@media only screen and (max-width: 37.5em) {
  .AppPage_topside__6Eu7D h3 {
    font-size: var(--default-font-subtitle);
  }
}

.AppPage_menuIcon__tSBZq {
  font-size: 3rem;
  color: var(--color-admin);
  cursor: pointer;
}
.AppPage_menuIcon__tSBZq:focus, .AppPage_menuIcon__tSBZq:hover {
  color: var(--color-primary-4);
}

.AppPage_mobileSidebar__\\+Qfgp {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 70vw 30vw;
  z-index: 100;
}

.AppPage_sidebar__PKlBz {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 30vw 70vw;
  z-index: 100;
  top: 0;
  left: 0;
}
.AppPage_sidebar__PKlBz > :nth-child(2) {
  cursor: pointer;
}
@media only screen and (max-width: 50em) {
  .AppPage_sidebar__PKlBz {
    grid-template-columns: 40vw 60vw;
  }
}
@media only screen and (max-width: 37.5em) {
  .AppPage_sidebar__PKlBz {
    grid-template-columns: 70vw 30vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Components/AppPage.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AADD;;AAIA;EACC,sBAAA;EACA,kBAAA;EACA,WAAA;AADD;AAGC;EALD;IAME,UAAA;EAAA;AACF;AAEC;EATD;IAUE,WAAA;EACA;AACF;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADD;AAGC;EACC,aAAA;EACA,mBAAA;AADF;AAEE;EACC,kBAAA;AAAH;AAIC;EACC,aAAA;EACA,mBAAA;AAFF;AAGE;EACC,kBAAA;AADH;AAKC;EACC,oCAAA;EACA,mBAAA;AAHF;AAMC;EACC,2BAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AAJF;AAOC;EACC,aAAA;EACA,mBAAA;AALF;AAOE;EAJD;IAKE,mBAAA;EAJD;AACF;AAQC;EACC,iCAAA;EACA,mBAAA;AANF;AAQE;EAJD;IAKE,uCAAA;EALD;AACF;;AASA;EACC,eAAA;EACA,yBAAA;EACA,eAAA;AAND;AAQC;EAEC,6BAAA;AAPF;;AAWA;EACC,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AARD;;AAWA;EACC,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AARD;AAUC;EACC,eAAA;AARF;AAWC;EAfD;IAgBE,gCAAA;EARA;AACF;AAUC;EAnBD;IAoBE,gCAAA;EAPA;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tmax-width: 100vw;\n\tpadding: 5rem;\t\n}\n\n.appright {\n\tbox-sizing: border-box;\n\tpadding: 3rem 3rem;\n\twidth: 80vw;\n\t\n\t@media only screen and (max-width: $bp-1000) {\n\t\twidth: 90%;\n\t}\n\n\t@media only screen and (max-width: $bp-800) {\n\t\twidth: 100%;\n\t}\n\n\n}\n\n.topside {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 2rem;\n\n\t&_left {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&_1 {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\t}\n\n\t&_welcome {\n\t\tfont-size: var(--default-font-small);\n\t\tline-height: 1.8rem;\n\t}\n\n\t&_name {\n\t\tcolor: var(--color-primary);\n\t\tfont-size: var(--default-font-subtitle);\n\t\tfont-weight: 700;\n\t\tline-height: 3rem;\n\t}\n\n\t&_icon {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\n\n\th3 {\n\t\tfont-size: var(--default-font-h3);\n\t\tline-height: 3.6rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tfont-size: var(--default-font-subtitle);\n\t\t}\n\t}\n}\n\n.menuIcon {\n\tfont-size: 3rem;\n\tcolor: var(--color-admin);\n\tcursor: pointer;\n\n\t&:focus,\n\t&:hover {\n\t\tcolor: var(--color-primary-4);\n\t}\n}\n\n.mobileSidebar {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: rgba(#2a2828, 0.7);\n\tposition: fixed;\n\tdisplay: grid;\n\tgrid-template-columns: 70vw 30vw;\n\tz-index: 100;\n}\n\n.sidebar {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: rgba(#2a2828, 0.7);\n\tposition: fixed;\n\tdisplay: grid;\n\tgrid-template-columns: 30vw 70vw;\n\tz-index: 100;\n\ttop: 0;\n\tleft: 0;\n\n\t& > :nth-child(2) {\n\t\tcursor: pointer;\n\t}\n\n\t@media only screen and (max-width: $bp-medium) {\n\t\tgrid-template-columns: 40vw 60vw;\n\t}\n\n\t@media only screen and (max-width: $bp-small) {\n\t\tgrid-template-columns: 70vw 30vw;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AppPage_container__5kV8S`,
	"appright": `AppPage_appright__FbFDS`,
	"topside": `AppPage_topside__6Eu7D`,
	"topside_left": `AppPage_topside_left__srd81`,
	"topside_1": `AppPage_topside_1__tBdsp`,
	"topside_welcome": `AppPage_topside_welcome__13qU2`,
	"topside_name": `AppPage_topside_name__7zj2X`,
	"topside_icon": `AppPage_topside_icon__i8-cz`,
	"menuIcon": `AppPage_menuIcon__tSBZq`,
	"mobileSidebar": `AppPage_mobileSidebar__+Qfgp`,
	"sidebar": `AppPage_sidebar__PKlBz`
};
export default ___CSS_LOADER_EXPORT___;
